import Vue from 'vue';
import VerifyRequestModel from '../../../generated/types/model/request/VerifyRequestModel';
import { IJSONSchema } from '../../../../plugins/validation/IJSONSchema';
import queryBuilder from '../../../../plugins/validation/queryBuilder';

export default class VerifyRequestViewModel extends VerifyRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}

  schema = {
    ...queryBuilder.properties({
      code: { required: true },
    }),
  } as IJSONSchema;
}
